/* Noirarchy product page behavior (sections/main-product.liquid). Deferred; loads
   after shrine.null.js, whose globals subscribe and PUB_SUB_EVENTS it uses. Shrine
   keeps doing the variant switch, the price and label refresh, the AJAX add and
   the drawer; this file adds the Noirarchy parts on top.

   Gallery     Per-variant media by alt text (snippets/product-media-gallery):
               slides, thumbnails, lightbox images and dots that belong to another
               value of an option get .noir-media-off; the dots, their labels and
               the "1 / 8" counter are recounted, Shrine's sliders are reset, and
               the stage jumps to the first image. Runs on load, on the picker's
               change event (at once) and on Shrine's variantChange (canonical).
               The round arrows ([data-noir-gallery-step]) wrap at the ends.
               Phones scroll the strip by hand, so it takes focus (tabindex 0) and
               keeps its "{title} photos" name; at 990px and up the stage has
               overflow-x hidden and media-gallery.js marks it presentation, so
               the tabindex and the name come off (syncStrip, on init, on every
               filter and on crossing 990px).
   Rows        collapsible_tab rows with data-noir-option-value show only while the
               selected variant has that option value. A row that hides also closes,
               so a variant change never brings a row back open.
   Added       After a successful add from this page's form (Shrine publishes
               cart-update with source 'product-form'), the bar reads its "added"
               label and the "Added. View your bag" link shows; both reset on the
               next variant change. The link opens the cart drawer when there is one.
               Every other cart-update (the drawer's remove and quantity buttons,
               card adds) re-reads /cart.js, or the event's cart when it carries
               one, and clears the Added state when no line holds the form's
               variant any more.
   Rating      The rating row's count links to #reviews only while that section is on
               the page: when the anchor is missing, the link becomes plain text and
               the row takes back role="img" and its label (snippets/noir-rating-row).
   Sticky bar  Desktop: visible only after the main Add to bag button has scrolled
               out of view above (IntersectionObserver; CSS applies the class at
               990px and up, phones always show the bar). Mirrors the main button's
               disabled state and label, and swaps the variant line on variantChange.

   API: window.Noir.product = { init(scope), filter(sectionId) }. */
(function () {
  'use strict';

  var Noir = (window.Noir = window.Noir || {});
  if (Noir.product && Noir.product.__ready) return;

  var ROOT = '[data-noir-pdp]';
  var PENDING_MS = 30000;
  var DESKTOP = '(min-width: 990px)';
  var pending = null;
  var hooked = false;
  var cartSeq = 0;
  var desktopQuery = window.matchMedia ? window.matchMedia(DESKTOP) : null;

  function lower(value) {
    return String(value === null || value === undefined ? '' : value).trim().toLowerCase();
  }

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function rootFor(sectionId) {
    var el = sectionId ? document.getElementById('MainProduct-' + sectionId) : null;
    return el && el.matches(ROOT) ? el : null;
  }

  function sectionOf(root) {
    return root.getAttribute('data-section') || '';
  }

  function mainButton(root) {
    return document.getElementById('ProductSubmitButton-' + sectionOf(root));
  }

  /* ---------- Variant data ---------- */
  function variantSelects(root) {
    return root.querySelector('variant-selects');
  }

  function variantList(root) {
    var vs = variantSelects(root);
    if (!vs) return null;
    if (vs.variantData) return vs.variantData;
    var el = vs.querySelector('script[type="application/json"]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function currentVariant(root) {
    var vs = variantSelects(root);
    if (vs && vs.currentVariant) return vs.currentVariant;
    var input = root.querySelector('#product-form-' + sectionOf(root) + ' input[name="id"]');
    var id = input ? parseInt(input.value, 10) : NaN;
    var list = variantList(root);
    if (!list || !id) return null;
    for (var i = 0; i < list.length; i++) {
      if (list[i].id === id) return list[i];
    }
    return null;
  }

  function optionsOf(variant) {
    if (!variant) return [];
    var opts = variant.options || [variant.option1, variant.option2, variant.option3];
    return toArray(opts).map(lower);
  }

  /* ---------- Gallery ---------- */
  /* data-noir-values="1:spiderweb|2:large": option position, then a value its alt names. */
  function belongs(el, opts) {
    var raw = el.getAttribute('data-noir-values');
    if (!raw) return true;
    var byPosition = {};
    raw.split('|').forEach(function (pair) {
      var cut = pair.indexOf(':');
      if (cut < 1) return;
      var position = pair.slice(0, cut);
      (byPosition[position] = byPosition[position] || []).push(pair.slice(cut + 1));
    });
    for (var position in byPosition) {
      if (!Object.prototype.hasOwnProperty.call(byPosition, position)) continue;
      var selected = opts[parseInt(position, 10) - 1];
      if (selected === undefined || selected === '') continue;
      if (byPosition[position].indexOf(selected) === -1) return false;
    }
    return true;
  }

  function visibleSlides(gallery) {
    var stage = gallery.querySelector('.noir-gallery__stage');
    if (!stage) return [];
    return toArray(stage.children).filter(function (slide) {
      return !slide.classList.contains('noir-media-off');
    });
  }

  function setScroll(list, left) {
    var previous = list.style.scrollBehavior;
    list.style.scrollBehavior = 'auto';
    list.scrollLeft = left;
    list.style.scrollBehavior = previous;
  }

  function markActive(gallery, slide) {
    toArray(gallery.querySelectorAll('.noir-gallery__stage > [data-media-id]')).forEach(function (el) {
      el.classList.toggle('is-active', el === slide);
    });
    var target = slide.getAttribute('data-media-id');
    toArray(gallery.querySelectorAll('[data-target] button')).forEach(function (button) {
      var item = button.closest('[data-target]');
      if (item && item.getAttribute('data-target') === target) button.setAttribute('aria-current', 'true');
      else button.removeAttribute('aria-current');
    });
  }

  function syncCounter(gallery, viewer, count) {
    if (count >= 2 && viewer && typeof viewer.update === 'function') {
      try {
        viewer.update();
        return;
      } catch (e) {
        /* fall through to the manual counter */
      }
    }
    var current = gallery.querySelector('.slider-counter--current');
    if (current) current.textContent = count ? '1' : '0';
  }

  function filterGallery(root, variant, jump) {
    var gallery = root.querySelector('[data-noir-gallery]');
    if (!gallery) return;
    var viewer = gallery.querySelector('[id^="GalleryViewer-"]');
    var stage = gallery.querySelector('.noir-gallery__stage');
    if (!viewer || !stage) return;
    var slides = toArray(stage.children).filter(function (el) {
      return el.hasAttribute('data-media-id');
    });
    if (!slides.length) return;

    var opts = optionsOf(variant);
    var on = {};
    var anyOn = false;
    slides.forEach(function (slide) {
      var keep = belongs(slide, opts);
      on[slide.getAttribute('data-media-id')] = keep;
      if (keep) anyOn = true;
    });
    /* Never an empty stage. */
    if (!anyOn) {
      slides.forEach(function (slide) {
        on[slide.getAttribute('data-media-id')] = true;
      });
    }

    slides.forEach(function (slide) {
      slide.classList.toggle('noir-media-off', !on[slide.getAttribute('data-media-id')]);
    });
    toArray(gallery.querySelectorAll('[data-target]')).forEach(function (thumb) {
      thumb.classList.toggle('noir-media-off', on[thumb.getAttribute('data-target')] === false);
    });

    /* The lightbox, when the section uses one. */
    var sid = sectionOf(root);
    var modal = document.getElementById('ProductModal-' + sid);
    if (modal) {
      toArray(modal.querySelectorAll('.product-media-modal__content > [data-media-id]')).forEach(function (el) {
        el.classList.toggle('noir-media-off', on[sid + '-' + el.getAttribute('data-media-id')] === false);
      });
    }

    var visible = visibleSlides(gallery);
    var count = visible.length;
    gallery.classList.toggle('noir-gallery--single', count < 2);

    var dotsWrap = gallery.querySelector('.noir-gallery__dots');
    var template = dotsWrap ? dotsWrap.getAttribute('data-noir-dot-label') : '';
    toArray(gallery.querySelectorAll('.slider-counter__link')).forEach(function (dot, i) {
      dot.classList.toggle('noir-media-off', i >= count);
      if (template) {
        dot.setAttribute('aria-label', template.replace('[index]', String(i + 1)).replace('[count]', String(count)));
      }
    });

    var total = gallery.querySelector('.slider-counter--total');
    if (total) total.textContent = String(count);

    /* Shrine's dot links measure the first slide; keep it a visible one. */
    if (visible[0]) viewer.sliderFirstItemNode = visible[0];

    [viewer, gallery.querySelector('[id^="GalleryThumbnails-"]')].forEach(function (slider) {
      if (slider && typeof slider.resetPages === 'function') {
        try {
          slider.resetPages();
        } catch (e) {
          /* a slider that never started has nothing to reset */
        }
      }
    });

    if (jump && visible[0]) {
      setScroll(stage, visible[0].offsetLeft);
      markActive(gallery, visible[0]);
    }
    syncCounter(gallery, viewer, count);
    syncStrip(gallery);
  }

  /* Round arrows: one image at a time, wrapping at both ends. */
  function step(gallery, direction) {
    var stage = gallery.querySelector('.noir-gallery__stage');
    var slides = visibleSlides(gallery);
    if (!stage || slides.length < 2) return;
    var width = slides[0].offsetWidth || stage.clientWidth || 1;
    var index = Math.round(stage.scrollLeft / width);
    if (index < 0) index = 0;
    if (index > slides.length - 1) index = slides.length - 1;
    var next = (index + direction + slides.length) % slides.length;
    stage.scrollTo({ left: slides[next].offsetLeft });
    markActive(gallery, slides[next]);
  }

  /* Below 990px the strip is the keyboard and screen reader control (the dots are
     decorative), so it is a named list that takes focus while it holds two or more
     photos. media-gallery.js sets role=presentation from 750px at load (it runs
     after this file, hence the second init on DOMContentLoaded), so tablets get
     the list back here. At 990px and up overflow-x is hidden and arrows and
     thumbnails move the stage; a tabindex or a name on a presentation element
     would conflict, so both come off. */
  function restoreName(stage) {
    var name = stage.getAttribute('data-noir-strip-label');
    if (name && stage.getAttribute('role') !== 'presentation') stage.setAttribute('aria-label', name);
  }

  function syncStrip(gallery) {
    var stage = gallery.querySelector('.noir-gallery__stage');
    if (!stage) return;
    var desktop = desktopQuery ? desktopQuery.matches : false;
    if (desktop) {
      stage.removeAttribute('tabindex');
      stage.removeAttribute('aria-label');
      return;
    }
    if (stage.getAttribute('role') === 'presentation') {
      stage.setAttribute('role', 'list');
      toArray(stage.children).forEach(function (slide) {
        if (slide.getAttribute('role') === 'presentation') slide.removeAttribute('role');
      });
    }
    if (visibleSlides(gallery).length < 2) stage.removeAttribute('tabindex');
    else stage.setAttribute('tabindex', '0');
    restoreName(stage);
  }

  function syncStrips() {
    toArray(document.querySelectorAll(ROOT + ' [data-noir-gallery]')).forEach(syncStrip);
  }

  /* ---------- Variant-specific accordion rows ---------- */
  function toggleRows(root, variant) {
    var opts = optionsOf(variant);
    toArray(root.querySelectorAll('[data-noir-option-value]')).forEach(function (row) {
      var hide = opts.indexOf(lower(row.getAttribute('data-noir-option-value'))) === -1;
      if (hide && row.classList.contains('is-open') && Noir.accordion && typeof Noir.accordion.close === 'function') {
        Noir.accordion.close(row);
      }
      row.hidden = hide;
    });
  }

  /* ---------- Rating row ---------- */
  function syncRating(root) {
    toArray(root.querySelectorAll('[data-noir-rating-row] a.noir-rating-row__count')).forEach(function (link) {
      var href = link.getAttribute('href') || '';
      var target = null;
      try {
        target = href.charAt(0) === '#' && href.length > 1 ? document.querySelector(href) : null;
      } catch (e) {
        target = null;
      }
      if (target) return;
      var row = link.closest('[data-noir-rating-row]');
      var text = document.createElement('span');
      text.className = 'noir-rating-row__count';
      text.textContent = link.textContent;
      link.parentNode.replaceChild(text, link);
      if (row) {
        row.setAttribute('role', 'img');
        row.setAttribute('aria-label', row.getAttribute('data-label') || text.textContent);
      }
    });
  }

  /* ---------- Labels, Added link, sticky bar ---------- */
  function applyLabels(root) {
    var button = mainButton(root);
    if (!button) return;
    var label = button.querySelector('.main-atc__label');
    var available = !button.disabled;
    var added = !!root.__noirAdded;
    if (label && available) {
      var text = added ? button.getAttribute('data-noir-added-label') : button.getAttribute('data-noir-label');
      if (text) label.textContent = text;
    }
    var sticky = root.querySelector('[data-noir-sticky] .noir-sticky__btn');
    if (sticky) {
      sticky.disabled = button.disabled;
      var stickyLabel = sticky.querySelector('.noir-sticky__label');
      if (stickyLabel) {
        if (!available) stickyLabel.textContent = label ? label.textContent : stickyLabel.textContent;
        else if (added) stickyLabel.textContent = button.getAttribute('data-noir-added-label') || stickyLabel.textContent;
        else stickyLabel.textContent = sticky.getAttribute('data-noir-label') || stickyLabel.textContent;
      }
    }
  }

  function setAdded(root, added) {
    root.__noirAdded = !!added;
    toArray(root.querySelectorAll('[data-noir-added-link]')).forEach(function (link) {
      link.hidden = !added;
    });
    applyLabels(root);
  }

  /* ---------- Added state against the cart ---------- */
  function formVariantId(root) {
    var input = root.querySelector('#product-form-' + sectionOf(root) + ' input[name="id"]');
    var id = input ? parseInt(input.value, 10) : NaN;
    return id || root.__noirVariantId || null;
  }

  function cartHolds(cart, id) {
    var items = cart && cart.items;
    if (!id || !items || !items.length) return false;
    for (var i = 0; i < items.length; i++) {
      var line = items[i];
      if (line && (line.variant_id === id || line.id === id) && line.quantity !== 0) return true;
    }
    return false;
  }

  function cartJsUrl() {
    var base = (window.routes && window.routes.cart_url) || '/cart';
    return base.replace(/\/+$/, '') + '.js';
  }

  /* skip: a root this same event has just marked Added. */
  function checkCart(data, skip) {
    var roots = toArray(document.querySelectorAll(ROOT)).filter(function (root) {
      return root !== skip && root.__noirAdded;
    });
    if (!roots.length) return;
    var seq = ++cartSeq;
    var given = data && data.cartData && Array.isArray(data.cartData.items) ? data.cartData : null;
    var ready = given
      ? Promise.resolve(given)
      : fetch(cartJsUrl(), { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (response) {
          if (!response.ok) throw new Error('cart ' + response.status);
          return response.json();
        });
    ready
      .then(function (cart) {
        /* A newer cart-update, or a fresh add, has taken over. */
        if (seq !== cartSeq) return;
        roots.forEach(function (root) {
          if (!root.__noirAdded || !document.documentElement.contains(root)) return;
          if (!cartHolds(cart, formVariantId(root))) setAdded(root, false);
        });
      })
      .catch(function () {
        /* Offline or blocked: leave the state as it is. */
      });
  }

  function syncStickyLine(root, html) {
    if (!html || typeof html.getElementById !== 'function') return;
    var id = 'noir-sticky-variant-' + sectionOf(root);
    var line = document.getElementById(id);
    var fresh = html.getElementById(id);
    if (line && fresh) line.textContent = fresh.textContent;
  }

  function initSticky(root) {
    var sticky = root.querySelector('[data-noir-sticky]');
    if (root.__noirObserver) {
      root.__noirObserver.disconnect();
      root.__noirObserver = null;
    }
    if (!sticky) return;
    var button = mainButton(root);
    if (!button || !('IntersectionObserver' in window)) {
      sticky.classList.add('is-visible');
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var top = entry.rootBounds ? entry.rootBounds.top : 0;
        var past = !entry.isIntersecting && entry.boundingClientRect.bottom <= top;
        sticky.classList.toggle('is-visible', past);
      });
    });
    observer.observe(button);
    root.__noirObserver = observer;
  }

  /* ---------- Variant changes ---------- */
  function onVariant(root, variant) {
    if (!variant) return;
    var changed = root.__noirVariantId !== variant.id;
    root.__noirVariantId = variant.id;
    filterGallery(root, variant, changed);
    toggleRows(root, variant);
    if (changed) setAdded(root, false);
  }

  /* The picker's own change event: runs right after Shrine's handler, before its fetch. */
  document.addEventListener('change', function (event) {
    var vs = event.target && event.target.closest ? event.target.closest('variant-selects') : null;
    if (!vs) return;
    var root = vs.closest(ROOT);
    if (!root || !vs.currentVariant) return;
    onVariant(root, vs.currentVariant);
  });

  /* Capture phase, before Shrine's submit handler. A submit from any other form clears it. */
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      var root = form && form.closest ? form.closest(ROOT) : null;
      /* getAttribute: a product form's input named "id" shadows form.id. */
      if (root && form.getAttribute('id') === 'product-form-' + sectionOf(root)) {
        pending = { root: root, at: Date.now() };
      } else {
        pending = null;
      }
    },
    true
  );

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var arrow = target.closest('[data-noir-gallery-step]');
    if (arrow) {
      var gallery = arrow.closest('[data-noir-gallery]');
      if (!gallery) return;
      event.preventDefault();
      step(gallery, parseInt(arrow.getAttribute('data-noir-gallery-step'), 10) < 0 ? -1 : 1);
      return;
    }

    var link = target.closest('[data-noir-added-link]');
    if (link) {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        event.preventDefault();
        drawer.open(link);
      }
    }
  });

  /* subscribe and PUB_SUB_EVENTS are globals from shrine.null.js. */
  function hook() {
    if (hooked) return;
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS) return;
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var data = event && event.data;
      if (!data) return;
      var root = rootFor(data.sectionId);
      if (!root) return;
      onVariant(root, data.variant);
      syncStickyLine(root, data.html);
      applyLabels(root);
    });
    /* Every source: product-form (this page or a card) and cart-items (drawer, /cart). */
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (data) {
      var marked = null;
      if (data && data.source === 'product-form' && pending) {
        var job = pending;
        pending = null;
        if (Date.now() - job.at <= PENDING_MS && document.documentElement.contains(job.root)) {
          /* Any cart check still in flight is older than this add. */
          cartSeq++;
          setAdded(job.root, true);
          marked = job.root;
        }
      }
      checkCart(data, marked);
    });
    hooked = true;
  }

  /* ---------- Init and theme editor ---------- */
  function init(scope) {
    hook();
    var base = scope || document;
    var roots = base.matches && base.matches(ROOT) ? [base] : toArray(base.querySelectorAll(ROOT));
    roots.forEach(function (root) {
      var variant = currentVariant(root);
      if (variant) {
        root.__noirVariantId = variant.id;
        filterGallery(root, variant, false);
        toggleRows(root, variant);
      }
      initSticky(root);
      syncRating(root);
      var gallery = root.querySelector('[data-noir-gallery]');
      if (gallery) syncStrip(gallery);
    });
  }

  function filter(sectionId) {
    var root = rootFor(sectionId);
    if (!root) return;
    var variant = currentVariant(root);
    if (variant) filterGallery(root, variant, true);
  }

  if (desktopQuery) {
    if (typeof desktopQuery.addEventListener === 'function') desktopQuery.addEventListener('change', syncStrips);
    else if (typeof desktopQuery.addListener === 'function') desktopQuery.addListener(syncStrips);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    toArray(event.target.querySelectorAll(ROOT)).forEach(function (root) {
      if (root.__noirObserver) root.__noirObserver.disconnect();
    });
  });

  Noir.product = { __ready: true, init: init, filter: filter };

  init();
  if (document.readyState !== 'complete') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  }
  if (!hooked) window.addEventListener('load', hook);
})();
